<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">{{ $t('payBasicSalary.pageTitle') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{ $t('payBasicSalary.employee') }}
                <i class="fas fa-spinner spin" v-if="fetchEmployee"></i>
              </label>
              <ts-search-select
                v-model.number="model.employee_id"
                :options="employees"
                :disable="fetchEmployee"
                :class="{ 'is-invalid': errors.has('employee_id') }"
              ></ts-search-select>
              <div class="invalid-feedback" v-if="errors.has('employee_id')">
                {{ errors.first('employee_id') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('payBasicSalary.salary') }}</label>
              <input
                v-model.number="model.salary"
                type="number"
                class="form-control"
                :class="{ 'is-invalid': errors.has('salary') }"
              />
              <div class="invalid-feedback" v-if="errors.has('salary')">
                {{ errors.first('salary') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('payBasicSalary.salaryAfterProbation')
              }}</label>
              <input
                v-model.number="model.salary_after_probation"
                type="number"
                class="form-control"
                :class="{ 'is-invalid': errors.has('salary_after_probation') }"
              />
              <div class="invalid-feedback" v-if="errors.has('salary_after_probation')">
                {{ errors.first('salary_after_probation') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('payBasicSalary.effectiveDate') }}</label>
              <ts-date-picker-input
                v-model="model.effective_date"
                :class="{ 'is-invalid': errors.has('effective_date') }"
              />
              <div class="invalid-feedback" v-if="errors.has('effective_date')">
                {{ errors.first('effective_date') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group m-b-10">
              <ts-checkbox v-model="model.payroll_visible">
                {{ $t('payBasicSalary.payrollVisible') }}
              </ts-checkbox>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">
              {{ $t('button.cancel') }}
            </ts-button>
            ​<ts-button
              outline
              color="primary"
              class="ml-2 primary"
              :waiting="savingAddNew"
              @click.prevent="saveAddNew"
              v-if="editData === undefined"
              >{{ $t('button.saveAddNew') }}</ts-button
            >
            ​<ts-button
              class="btn-primary ml-2"
              :waiting="saving"
              @click.prevent="store"
              v-if="editData === undefined"
              >{{ $t('button.save') }}</ts-button
            >
            ​<ts-button class="btn-primary ml-2" :waiting="saving" @click.prevent="update" v-if="editData">{{
              $t('button.update')
            }}</ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'form-basic-salary',
  props: ['editData'],
  data() {
    return {
      model: {
        employee_id: '',
        salary: '',
        salary_after_probation: '',
        payroll_visible: false,
        effective_date: ''
      },
      errors: new Errors(),
      fetchEmployee: false,
      saving: false,
      savingAddNew: false
    }
  },
  created() {
    this.fetchDataBeforeCreate()
  },
  computed: {
    employees() {
      return this.$store.state.hr.payBasicSalary.employees.map(el => ({
        value: el.employee_id,
        text: el.employee_name_en
      }))
    }
  },
  methods: {
    fetchDataBeforeCreate() {
      this.fetchEmployee = true
      this.$store
        .dispatch('hr/payBasicSalary/dataBeforeCreate')
        .then(response => {
          this.fetchEmployee = false
          this.setEditData()
        })
        .catch(error => {
          this.fetchEmployee = false
          this.$toasted.error(error.message)
        })
    },
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/payBasicSalary/update', {
          id: this.editData.id,
          data: this.model
        })
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetchData()
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    store() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/payBasicSalary/store', this.model)
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetchData()
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    saveAddNew() {
      this.errors = new Errors()
      this.savingAddNew = true
      this.$store
        .dispatch('hr/payBasicSalary/store', this.model)
        .then(response => {
          this.savingAddNew = false
          this.$toasted.success(response.message)
          this.fetchData()
          this.clearInput()
        })
        .catch(error => {
          this.savingAddNew = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    fetchData() {
      this.$store.dispatch('hr/payBasicSalary/fetch').catch(error => {
        this.$toasted.error(error.message)
      })
    },
    setEditData() {
      if (!_.isEmpty(this.editData)) {
        this.model = {
          employee_id: this.editData.employee_id,
          salary: this.editData.salary,
          salary_after_probation: this.editData.salary_after_probation,
          payroll_visible: this.editData.payroll_visible,
          effective_date: this.editData.effective_date
        }
      }
    },
    clearInput() {
      this.model = {
        employee_id: '',
        salary: '',
        salary_after_probation: '',
        payroll_visible: false,
        effective_date: ''
      }
    }
  }
}
</script>
